export default __webpack_public_path__ + "static/feature-banner-ski-resorts-b5cb8e80d84339829a5fc5c0e664314f.jpg";